import { z } from "zod";

const envVariables = z.object({
    ENVIRONMENT: z
        .enum([
            "production",
            "preproduction",
            "staging",
            "development",
            "test-artifacts",
        ])
        .or(z.string().regex(/^xp[0-9]+$/)),
    ENABLE_SENTRY_REPORTING: z.enum(["true", "false"]).optional(),
    SENTRY_RELEASE_ID: z.string().optional(),
    SENTRY_DSN: z.string().optional(),
    IMPERO_HCAPTCHA_SITE_KEY: z.string(),
    LOCIZE_PROJECT_ID: z.string().optional(),
    PREVIEW_DEPLOYMENT: z.enum(["true", "false"]).optional(),
});

export const commonEnvShape = envVariables.shape;

export const readCommonEnvVariables = () => ({
    SENTRY_RELEASE_ID: import.meta.env.VITE_SENTRY_RELEASE_ID,
    ENABLE_SENTRY_REPORTING: import.meta.env.VITE_ENABLE_SENTRY_REPORTING,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    IMPERO_HCAPTCHA_SITE_KEY: import.meta.env.VITE_IMPERO_HCAPTCHA_SITE_KEY,
    LOCIZE_PROJECT_ID: import.meta.env.VITE_LOCIZE_PROJECT_ID,
    PREVIEW_DEPLOYMENT: import.meta.env.VITE_PREVIEW_DEPLOYMENT,
});

export const ENVIRONMENT = envVariables.parse(readCommonEnvVariables());
